export const generateSchemaForFAQ = (faqs) => {
  const obj = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };

  return obj;
};

export const generateSchemaForReviews = (event) => {
  const obj = {
    "@context": "https://schema.org/",
    "@type": "Online Puja",
    url: "https://utsavapp.in/puja/" + event.urlExtension,
    description: event.description,
    image: event.images[0],
    name: event.name,
    review: event.ReviewModels.map((review) => ({
      "@type": "Review",
      reviewRating: {
        "@type": "Rating",
        ratingValue: review.rating,
      },
      author: {
        "@type": "Person",
        name: review.User.name,
      },
    })),
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: event.rating,
      bestRating: "5",
      ratingCount: event.ReviewModels.length,
    },
  };

  return obj;
};

export const generateSchemaForEvents = (subEvent) => {
  const obj = {
    "@context": "https://schema.org/",
    "@type": "Online Puja",
    item_group_id: subEvent.eventID,
    id: subEvent.subEventID,
    image_link: subEvent.images[0],
    brand: subEvent.communityName,
    google_product_category: subEvent.eventName + " > " + subEvent.name,
    fb_product_category: subEvent.eventName + " > " + subEvent.name,
    description: subEvent.description,
    title: subEvent.name,
    price: subEvent.amount + " INR",
    link:
      "https://utsavapp.in/puja/registration/" +
      subEvent.eventID +
      "/" +
      subEvent.subEventID,
  };

  return obj;
};

export const generateSchemaForBlog = ({
  pageUrl,
  headline,
  blogContent,
  img,
  author_name,
  published_time,
  keywords,
  wordCount,
}) => {
  try {
    let datePublished = published_time
      .toLocaleDateString()
      .split("/")
      .reverse();
    datePublished = datePublished.map((e) => (Number(e) < 10 ? "0" + e : e));
    datePublished = datePublished.join("-");

    const obj = {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id": pageUrl,
      },
      headline: headline,
      description: blogContent,
      image: img,
      // image: {
      //   "@type": "ImageObject",
      //   url: img,
      //   width: "",
      //   height: "",
      // },
      author: {
        "@type": "Organization",
        // name: author_name,
        name: "Utsav App",
        url: "https://utsavapp.in",
      },
      publisher: {
        "@type": "Organization",
        name: "Utsav App",
        logo: {
          "@type": "ImageObject",
          url: "https://yt3.ggpht.com/ytc/AKedOLQGbAKixMk6KYgpHzIhr8toTKk3RCuyzgPc989W=s900-c-k-c0x00ffffff-no-rj",
          width: "",
          height: "",
        },
      },
      datePublished: datePublished,
      articleSection: "Blogs",
      keywords: [keywords],
      wordCount: wordCount,
    };

    return obj;
  } catch (err) {
    //console.log(err);

    return null;
  }
};

export const OrganizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Utsav App",
  alternateName: "Utsav - My Temple & Festivals",
  url: "https://utsavapp.in/",
  logo: "https://yt3.ggpht.com/ytc/AKedOLQGbAKixMk6KYgpHzIhr8toTKk3RCuyzgPc989W=s900-c-k-c0x00ffffff-no-rj",
  contactPoint: {
    "@type": "ContactPoint",
    telephone: `+917439638404`,
    contactType: "Founder & CTO",
    areaServed: "IN",
    availableLanguage: "en",
  },
  sameAs: [
    "https://www.instagram.com/utsav_app/?igshid=1c1hf70ikuzq5",
    "https://www.facebook.com/utsav.app.community",
    "https://www.linkedin.com/company/utsavapp",
    "https://www.twitter.com/utsav_app",
  ],
};
